import { FaqItem } from './Faq.types';

export const makeStructuredData = (faqItems: FaqItem[] = []) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((faq) => {
      return {
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.plainTextAnswer,
        },
      };
    }),
  };
};
